import { Component, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { Grid } from "app/interfaces/grid.interface";
import { _GridService } from "app/ng1-services/grid.service";
import { _OrganizationService } from "app/services/organization.service";
import { _TradingAccountService } from "app/services/tradingAccount.service";
import { jqxGridComponent } from "assets/jqwidgets-ts/angular_jqxgrid";

declare var $: any;
declare let dialogCreate: any;
declare let dialogOpen: any;

@Component({
  selector: "organizations",
  templateUrl: "organizations.component.html",
  styleUrls: ["organizations.component.css"],
})
export class OrganizationsBranch {
  @ViewChild("organizationListGrid") organizationListGrid: jqxGridComponent;

  private organizationList: Grid;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private gridService: _GridService,
    private organizationService: _OrganizationService,
    private tradingAccountService: _TradingAccountService
  ) {}

  ngOnInit() {
    //Set the page title
    this.titleService.setTitle("WiseRisk | Organization Settings");

    $(document).ready(function () {
      dialogCreate("#confirmClearDemoData", function () {
        $.post("/ajax/demo-data/clear");
      });

      dialogCreate("#confirmResetDemoData", function () {
        $.post("/ajax/demo-data/reset", {
          accountGroups: true,
          accounts: true,
          liquidityProviders: true,
          currencyGroups: true,
          organizationHolidays: true,
          minimumOrderQuantities: true,
          assetQuantityRatios: true,
          ruleConditions: true,
          ruleConstraints: true,
        });
      });

      dialogCreate("#confirmSendTrades", function () {
        $.post("/ajax/demo-data/asset-positions");
      });

      dialogCreate("#confirmFillOrders", function () {
        $.post("/ajax/demo-data/fill-fx-order-recommendations");
      });

      $("#clearDemoData").click(function () {
        dialogOpen("#confirmClearDemoData");
      });

      $("#resetDemoData").click(function () {
        dialogOpen("#confirmResetDemoData");
      });

      $("#sendTrades").click(function () {
        dialogOpen("#confirmSendTrades");
      });

      $("#fillOrders").click(function () {
        dialogOpen("#confirmFillOrders");
      });

      $("#saveBtn").click(function (event) {
        //var frm = $('#organizationForm').serialize(); // serialize all the data in the form
        event.preventDefault();
        var organizationName = $("#displayName").val();
        var frm = {
          displayName: organizationName,
          baseCurrency: "USD",
        };

        $.ajax({
          type: "POST",
          url: "/ajax/organization",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          dataType: "json",
          data: JSON.stringify(frm),
          success: function (data) {
            alert("Organization Created Successfully!"); // show response from the php script.
          },
        });
      });
    });

    this.loadOrganizationList();
  }

  loadOrganizationList() {
    this.organizationList = null;
    this.organizationService.getOrganizationListForAdmin().then((data) => {
      var msgContainer = "organizationListMsg";
      let entityDropDown = null;
      var source = {
        id: "organizationListId",
        localdata: data,
        datafields: [
          {
            name: "organizationId",
            type: "int",
          },
          {
            name: "displayName",
            type: "string",
          },
          {
            name: "tradingProvider",
            type: "string",
          },
          {
            name: "baseCurrency",
            type: "string",
          },
          {
            name: "circleType",
            type: "string",
          },
          {
            name: "enabled",
            type: "checkbox",
          },
        ],
        updaterow: (rowid, rowdata, commit) => {
          if (!rowdata.tradingProvider) {
            rowdata.tradingProvider = null;
          }

          //New Row
          if (rowdata.rowId < 1) {
            this.organizationService
              .createOrganization(rowdata)
              .toPromise()
              .then(
                (data) => {
                  this.gridService.SuccessMsg(
                    msgContainer,
                    "Organization Added"
                  );
                  this.loadOrganizationList();
                },
                (data) => {
                  this.gridService.ErrorMsg(msgContainer, data);
                }
              );
          } else {
            this.organizationService
              .updateOrganization(rowdata.organizationId, rowdata)
              .toPromise()
              .then(
                (data) => {
                  this.gridService.SuccessMsg(
                    msgContainer,
                    "Organization Updated"
                  );
                  this.loadOrganizationList();
                },
                (data) => {
                  this.gridService.ErrorMsg(msgContainer, data);
                }
              );
          }
        },
        deleterow: (rowdata) => {
          this.organizationService
            .deleteOrganization(rowdata.organizationId)
            .toPromise()
            .then(
              (data) => {
                this.gridService.SuccessMsg(
                  msgContainer,
                  "Organization Deleted"
                );
                this.loadOrganizationList();
              },
              (data) => {
                this.gridService.ErrorMsg(msgContainer, data);
              }
            );
        },
        refresh: () => {
          this.loadOrganizationList();
        },
        getGrid: () => {
          return this.organizationListGrid;
        },
      };
      this.organizationList = {
        source,
        dataAdapter: new $.jqx.dataAdapter(source),
        columns: [
          {
            text: "Organization",
            columntype: "textbox",
            datafield: "displayName",
            width: "150",
          },
          {
            text: "Trading provider",
            columntype: "dropdownlist",
            datafield: "tradingProvider",
            width: "150",
            createeditor: async (
              row,
              cellvalue,
              editor,
              celltext,
              cellwidth,
              cellheight
            ) => {
              var organizationId = this.organizationListGrid.getcellvalue(
                row,
                "organizationId"
              );

              editor.jqxDropDownList({
                source:
                  this.gridService.GetTradingProviderDataAdapter(
                    organizationId
                  ),
                displayMember: "tradingName",
                valueMember: "tradingName",
              });
            },
          },
          {
            text: "Base currency",
            columntype: "dropdownlist",
            datafield: "baseCurrency",
            width: "100",
            createeditor: (row, cellvalue, editor) => {
              editor.jqxDropDownList({
                source: this.gridService.GetCurrencyDataAdapter(false, true),
                displayMember: "currency",
                valueMember: "currency",
              });
            },
          },
          {
            text: "Circle",
            columntype: "dropdownlist",
            datafield: "circleType",
            width: "100",
            createeditor: (row, cellvalue, editor) => {
              editor.jqxDropDownList({
                source: ["MONTHLY", "QUARTERLY", "ANNUALLY"],
              });
            },
          },
          {
            text: "Enabled",
            columntype: "checkbox",
            datafield: "enabled",
            width: "100",
          },
        ],
        renderstatusbar: (statusbar: any) => {
          this.gridService.RenderStatusBar(statusbar, source);
        },
      };
    });
  }

  onRowClick(event: any) {
    const args = event.args;
    const row = args.row;

    const data = row.bounddata;
    // row contains the clicked row's data. Use it as needed.
    console.log("Clicked row:", data);
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/settings/organizations/organizations.component.ts